import gideon from "../images/speakers/gideon.jpeg";
import danielle from "../images/speakers/danielle.jpeg";
import nick from "../images/speakers/nick.jpeg";
import daniel from "../images/speakers/daniel.jpeg";
import susan from "../images/speakers/susan.jpeg";
import angus from "../images/speakers/angus.jpeg";
import alejandro from "../images/speakers/alejandro.jpeg";
import isikov from "../images/speakers/isikov.jpg";
import cristianablw from "../images/speakers/cristianablw.jpg";
import harry from "../images/speakers/harry.jpg";
import martina from "../images/speakers/martina.jpg";
import alisa from "../images/speakers/alisa.jpg";
import kia from "../images/speakers/kia.jpg";
import abie from "../images/speakers/abie.png";
import steven from "../images/speakers/steven.png";
import steve from "../images/speakers/steve.png";
import feliz from "../images/speakers/feliz.png";
import bill from "../images/speakers/bill.png";
import zachary from "../images/speakers/zachary.png";
import tara from "../images/speakers/tara.png";
import marques from "../images/speakers/marques.jpg";
import christina from "../images/speakers/christina.jpg";
import Francois from "../images/speakers/Francois.jpg";
import colin from "../images/speakers/colin.png";
import geo from "../images/speakers/geo.jpg";
import michelle from "../images/speakers/michelle.png";
import asaf from "../images/speakers/asaf.jpeg";
import dave from "../images/speakers/dave.png";
import david from "../images/speakers/david.png";
import aidan from "../images/speakers/aidan.jpg";
import max from "../images/speakers/max.jpg";
import adam from "../images/speakers/adam.jpg";
import lauren from "../images/speakers/lauren.png";
import sarah from "../images/speakers/sarah.png";
import kaplan from "../images/speakers/kaplan.jpeg";
import tavel from "../images/speakers/tavel.png";
import kelly from "../images/speakers/kelly.jpg";
import jennifer from "../images/speakers/jennifer.jpg";
import tom from "../images/speakers/tom.avif";

import blueblack from "../images/speakers/blueblack.avif";

import "../styles/home/Speaker2.css";


const Speaker2Att = () => {
  return (
    <div className="container">
        <h2 className="textSize" style={{ color: "blue" }}>
        MEET OUR 2023 SPEAKERS
      </h2>
      <div className="inner-container">
        <table>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={adam} />
                <p className="image-text">
                  Adam Selipsky
                  <br />
                  CEO
                  <br />
                  Amazon Web Services
                </p>
              </div>
            </td>

            <td>
              <div className="image">
                <img className="image-contain" src={tara} />
                <p className="image-text">
                  Tara Bunch <br />
                  Global Head of Operations
                  <br />
                  Airbnb{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={marques} />
                <p className="image-text">
                  Marques Brownlee <br />
                  YouTuber and podcaster <br />
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={christina} />
                <p className="image-text">
                  Christina Cacioppo <br />
                  Co-founder &amp; CEO <br />
                  Vanta{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={Francois} />
                <p className="image-text">
                  François-Philippe Champagne
                  <br />
                  Minister of Innovation, Science &amp; Industry
                  <br />
                  Government of Canada
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={colin} />
                <p className="image-text">
                  Colin Murdoch <br />
                  Chief Business Officer <br />
                  Google DeepMind{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={geo} />
                <p className="image-text">
                  Geoffrey Hinton <br />
                  Godfather of AI <br />
                  University of Toronto{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={michelle} />
                <p className="image-text">
                  Michelle Zatlyn
                  <br />
                  Co-founder, President &amp; COO <br />
                  Cloudfare
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={asaf} />
                <p className="image-text">
                  Assaf Rappaport <br />
                  Co-founder &amp; CEO <br />
                  Wiz{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={dave} />
                <p className="image-text">
                  Dave Rogenmoser
                  <br />
                  Co-founder &amp; CEO <br />
                  Jasper{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={david} />
                <p className="image-text">
                  David Singleton <br />
                  CTO <br />
                  Stripe
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={aidan} />
                <p className="image-text">
                  Aidan Gomez
                  <br />
                  Founder &amp; CEO <br />
                  Cohere{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={max} />
                <p className="image-text">
                  Max Lytvyn <br />
                  Co Founder <br />
                  Grammarly
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={lauren} />
                <p className="image-text">
                  Lauren Kolodny <br />
                  Co-founder &amp; Managing Partner
                  <br />
                  Acrew Capital{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={sarah} />
                <p className="image-text">
                  Sarah Guo
                  <br />
                  Founder <br />
                  Conviction
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={kaplan} />
                <p className="image-text">
                  Lauren Kolodny <br />
                  Co-founder &amp; Managing Partner
                  <br />
                  Acrew Capital{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={tavel} />
                <p className="image-text">
                  Sarah Tavel
                  <br />
                  General Partner <br />
                  Benchmark
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={kelly} />
                <p className="image-text">
                  Kelly Burton <br />
                  CEO
                  <br />
                  Black Innovation Alliance{" "}
                </p>
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={jennifer} />
                <p className="image-text">
                  Jennifer McKelvie
                  <br />
                  Deputy Mayor of Toronto <br />
                  City of Toronto{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={tom} />
                <p className="image-text">
                  Tom Verrilli
                  <br />
                  Chief Product Officer
                  <br />
                  Twitch{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={gideon} />
                <p className="image-text">
                  Gideon Lichfield <br />
                  Global Editorial Director <br />
                  Wired{" "}
                </p>
              </div>
            </td>

            <td>
              <div className="image">
                <img className="image-contain" src={danielle} />
                <p className="image-text">
                  Danielle Belton <br />
                  Editor-in-chief <br />
                  HuffPost{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={nick} />
                <p className="image-text">
                  Nick Thompson
                  <br />
                  CEO <br />
                  The Atlantic{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={abie} />
                <p className="image-text">
                  Abbie Lundberg <br />
                  Editor-in-chief
                  <br />
                  MIT Sloan Management Review{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={steven} />
                <p className="image-text">
                  Steven Levy
                  <br />
                  Editor-at-large
                  <br />
                  Wired{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={daniel} />
                <p className="image-text">
                  Daniel Klaidman <br />
                  Editor-in-Chief <br />
                  Yahoo! News{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={susan} />
                <p className="image-text">
                  Susan Li <br />
                  Business Correspondent <br />
                  Fox Business{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={steve} />
                <p className="image-text">
                  Steve Clemons
                  <br />
                  Founding editor-at-large <br />
                  Semafor{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={feliz} />
                <p className="image-text">
                  Felice Maranz <br />
                  Editor of Markets Live <br />
                  Bloomberg{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={bill} />
                <p className="image-text">
                  Bill Owens <br />
                  Executive Producer of 60 Minutes
                  <br />
                  CBS News{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={isikov} />
                <p className="image-text">
                  Michael Isikoff <br />
                  Chief Investigative Correspondent <br />
                  Yahoo! News{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={cristianablw} />
                <p className="image-text">
                  Cristiana Sousa Cruz
                  <br />
                  Deputy Editor-in-chief <br />
                  GLOBO{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={harry} />
                <p className="image-text">
                  Harry McCracken
                  <br />
                  Global Technology Editor <br />
                  Fast Company
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={blueblack} />
                <p className="image-text">
                  DeRay Mckesson <br />
                  Civil Rights Activist &amp; Podcaster <br />
                  pod save the people{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={kia} />
                <p className="image-text">
                  Kia Kokalitcheva
                  <br />
                  Technology &amp; VC Reporter
                  <br />
                  Axios{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={zachary} />
                <p className="image-text">
                  Zachary Karabell <br />
                  Contributor <br />
                  Time{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={martina} />
                <p className="image-text">
                  Martina Fuchs <br />
                  Business Correspondent <br />
                  Xinhua News Agency{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={alisa} />
                <p className="image-text">
                  Alisa Cohn
                  <br />
                  Contributor <br />
                  Forbes{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={angus} />
                <p className="image-text">
                  Angus Loten
                  <br />
                  Enterprise Reporter <br />
                  The Wall Street Journal
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={alejandro} />
                <p className="image-text">
                  Alejandro de la Garza <br />
                  Staff Writer <br />
                  Time{" "}
                </p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};
export default Speaker2Att;
